"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountTrackerSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
/**
 * Трекер действий пользователя
 *   достижение трекера приводит к изменению ранга, сегмента или присвоению достижения
 */
exports.AccountTrackerSchema = zod_1.z.object({
  tracker: zod_1.z.nativeEnum(lingo2_models_1.UserTrackerEnum),
  /** Дата начала отсчёта */
  created_at: zod_1.z.string().datetime().or(zod_1.z.date()),
  /** До какой даты отсчёт */
  due_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional(),
  /** Предельное значение показателя */
  limit: zod_1.z.number(),
  /** Текущее значение показателя */
  value: zod_1.z.number(),
  /** Дата достижения показателя */
  passed_at: zod_1.z.string().datetime().or(zod_1.z.date()).or(zod_1.z.null()).optional()
});
